import type { PageCard } from '@/play/pageTypes'
import { DigCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'dig-for-eyes',
  number: 10,
  title: 'Dig',
  question: 'Is finding things buried in sand a good first game?',
  status: 'open',
  accent: '#f1dfb6',
  CardArt: DigCardArt,
}
